<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';

const props = withDefaults(defineProps<{
    contained?: boolean;
    empty?: boolean;
    loading?: boolean;
    class?: HTMLAttributes['class'];
    rowsClass?: HTMLAttributes['class'];
}>(), {
    contained: true,
    empty: false,
    loading: false,
    class: '',
    rowsClass: '',
});
</script>

<template>
    <div
        :class="cn(
            props.contained
                ? 'overflow-hidden rounded-xl border border-border/70 bg-card shadow-none'
                : 'overflow-hidden border-t border-border/70',
            props.class,
        )"
    >
        <div v-if="loading" class="space-y-3 px-4 py-5 sm:px-6">
            <slot name="loading">
                <div v-for="index in 3" :key="index" class="flex items-center gap-3 py-2">
                    <Skeleton class="size-9 shrink-0 rounded-lg" />
                    <div class="min-w-0 flex-1 space-y-2"><Skeleton class="h-4 w-1/3" /><Skeleton class="h-3 w-2/3" /></div>
                    <Skeleton class="h-6 w-16 rounded-full" />
                </div>
            </slot>
        </div>

        <div
            v-else-if="empty"
            class="px-4 py-8 sm:px-6"
        >
            <slot name="empty" />
        </div>

        <div
            v-else
            :class="cn('divide-y divide-border/60', props.rowsClass)"
        >
            <slot />
        </div>
    </div>
</template>
